import tippy from 'tippy.js'

tippy('.clipboardable', {
  content: 'Code copié',
  trigger: 'click',
  placement: 'top-end'
})
